module.exports = __webpack_public_path__ + "static/img/avatar.61151ed8.png";